import React from "react";
import { ACTIVE_ALERTS } from "../../mock/summary.mock";

const SEVERITY = [
  { key: "high", label: "High", color: "bg-red-500" },
  { key: "medium", label: "Med", color: "bg-orange-400" },
  { key: "low", label: "Low", color: "bg-yellow-400" },
];

export default function ActiveAlerts() {
  const total = ACTIVE_ALERTS.high + ACTIVE_ALERTS.medium + ACTIVE_ALERTS.low;

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <span className="text-2xl font-bold text-navy-700 dark:text-white">
          {total}
        </span>
        <div className="flex gap-2">
          {SEVERITY.map(({ key, label, color }) => (
            <span
              key={key}
              className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400"
            >
              <span className={`inline-block h-2 w-2 rounded-full ${color}`} />
              {ACTIVE_ALERTS[key]} {label}
            </span>
          ))}
        </div>
      </div>
      <button className="text-xs font-medium text-brand-500 hover:underline dark:text-brand-400">
        View all
      </button>
    </div>
  );
}
